// extracted by mini-css-extract-plugin
export default {"listForm":"ListForm_listForm__X05BA","title":"ListForm_title__15eDt"};